














import Vue from 'vue';
import { RouteName } from './router';
import { EXERCISE_LOAD_ALL_ACTION } from './store/exercise.store';

export default Vue.extend({
  created() {
    this.$store.dispatch(EXERCISE_LOAD_ALL_ACTION, this.$database);
  },
  methods: {
    getRouteObject(name: RouteName) {
      return { name };
    },
  },
  data: function() {
    return {
      RouteName,
    };
  },
});
